import { useMatch } from "react-router-dom";
import { useRecord } from "@/sync/hooks";

/** Works anywhere in the tree (sidebar, palette), not only under the `/p/:projectId` route. */
export function useCurrentProject() {
	const match = useMatch({ path: "/p/:projectId", end: false });
	const projectId = match?.params.projectId;
	const project = useRecord("project", projectId);
	return { projectId: project ? projectId : undefined, project };
}

export const lastProjectKey = (workspaceId: string) => `gridcast:last-project:${workspaceId}`;
